module.exports = __webpack_public_path__ + "static/logo-076c8f69bb0740aef64f0a35c3c1ce09.png";